import { SVGProps } from "react";

const IconOccupancies = (props: SVGProps<SVGSVGElement>) => {
    const { className, ...rest } = props;

    return (
        <svg
            className={className}
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden
            {...rest}
        >
            <rect
                x="1"
                y="2"
                width="20"
                height="17.2446"
                rx="3"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <rect
                x="3.98047"
                y="8.90088"
                width="2.63232"
                height="2.63232"
                rx="1"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <rect
                x="9.24512"
                y="8.90088"
                width="2.63232"
                height="2.63232"
                rx="1"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <rect
                x="3.98047"
                y="13.8774"
                width="2.63232"
                height="2.63232"
                rx="1"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <rect
                x="9.24512"
                y="13.8774"
                width="2.63232"
                height="2.63232"
                rx="1"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <rect
                x="15.3867"
                y="13.8774"
                width="2.63232"
                height="2.63232"
                rx="1"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <line
                x1="1"
                y1="6.25"
                x2="21"
                y2="6.25"
                stroke="currentColor"
                strokeWidth="1.5"
            />
            <line
                x1="11.042"
                y1="0.75"
                x2="11.042"
                y2="3.25"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <line
                x1="4.75"
                y1="0.75"
                x2="4.75"
                y2="3.25"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <line
                x1="17.2314"
                y1="0.75"
                x2="17.2314"
                y2="3.25"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <path
                d="M14.5098 10.0842L15.96 11.5332L18.0195 8.90088"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
        </svg>
    );
};

export default IconOccupancies;
